define([
	"dojo/_base/declare",
	"csi/form/Widget",
	"csi/sessionConstants"
], function(declare,Widget,sessionConstants) {

	return declare(Widget, {
		_hideExpressions: {
			IsReservation: '!hasGlobalRole(["Stock Order Administrator"])'
		},

		_resolveView: function() {
			// summary: set default value for requester
			this.addDefaultValue("SORequester", sessionConstants.userUrl);
			this.inherited(arguments);
		}
	});
});